import { useResourcePreviewChanges } from './changeContext';
import ResourcePreviewChangeBoundary from './ResourcePreviewChangeBoundary';
import ResourcePreviewField, { ResourcePreviewFieldProps } from './ResourcePreviewField';

/** Keep tab identity and ordering changes on the actual tab, not in a replacement diff document. */
const ResourcePreviewTabLabel = ({ children, resourceId, resourceType }: Omit<ResourcePreviewFieldProps, 'field'>) => {
    const preview = useResourcePreviewChanges();
    const orderField = resourceType === 'reports' ? 'orderIndex' : 'order';
    const orderChange =
        preview && preview.resourceId === resourceId && preview.resourceType === resourceType
            ? preview.changes.find((change) => change.path === orderField)
            : undefined;
    return (
        <ResourcePreviewChangeBoundary inline resourceId={resourceId ?? ''} resourceType={resourceType}>
            <ResourcePreviewField field='name' resourceId={resourceId} resourceType={resourceType}>
                {children}
            </ResourcePreviewField>
            {orderChange && preview?.highlightChanges && (
                <span style={{ marginLeft: '0.375rem' }} aria-label='Tab position changed'>
                    <ResourcePreviewField field={orderField} resourceId={resourceId} resourceType={resourceType}>
                        {orderChange.after}
                    </ResourcePreviewField>
                </span>
            )}
        </ResourcePreviewChangeBoundary>
    );
};

export default ResourcePreviewTabLabel;
